import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { TablePagination } from "../models/components/table/table-pagination.model";
import { ParticipantContextProps } from "../models/contexts/participant-context.model";
import { Formatter } from "../services/formatter/formatter.service";

export const usePastAppointments = (
	participantContext: ParticipantContextProps,
	pagination: TablePagination
) => {
	const participant = participantContext.participant;
	const participantId = participant ? participant.kannactId : null;
	const queryClient = useQueryClient();
	const queryKey = ["past-appointments", { participantId }];
	const query = useQuery({
		queryKey: ["past-appointments", { participantId, pagination }],

		queryFn: async () => {
			if (!participant) return [];

			const maxDate = Formatter.formatDateAppointments(new Date());
			const ptEmail = participant.emails?.find((x) => x.isPrimary)?.emailAddress;

			return await EndpointsService.appointments.getAppointmentsByParticipant({
				config: {
					params: {
						minDate: "2021-01-01",
						maxDate,
						kannactId: participant.kannactId,
						email: ptEmail,
					},
				},
			});
		},

		enabled: !!participant,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
